import { observer } from 'mobx-react-lite'
import DialogActions from '@mui/material/DialogActions'
import GapDialogActionButton from './GapDialogActionButton'
import { useGapDialogStore } from './GapDialogStore'

export default observer(function GapDialogActionButtons() {
    const gapDialogStore = useGapDialogStore()
    const primary = gapDialogStore.childOptions?.primaryButton || gapDialogStore.buttons.primary
    const secondary = gapDialogStore.buttons.secondary
    const hasFullWidthButtons = primary?.fullWidth || secondary?.fullWidth
    const bothFullWidth = primary?.fullWidth && secondary?.fullWidth

    return <DialogActions sx={{ mb: 1, ...(hasFullWidthButtons && { display: 'flex', px: 3 }) }}>
        {
            gapDialogStore.cancelOption && <GapDialogActionButton action={gapDialogStore.cancelOption} variant='cancel' />
        }

        {
            secondary && <GapDialogActionButton action={secondary} variant='secondary' sx={secondary.fullWidth ? { flex: bothFullWidth ? 1 : undefined, width: bothFullWidth ? undefined : '100%' } : undefined} />
        }

        {
            primary && <GapDialogActionButton action={primary} variant='primary' sx={primary.fullWidth ? { flex: bothFullWidth ? 1 : undefined, width: bothFullWidth ? undefined : '100%' } : undefined} />
        }
    </DialogActions>
})
